/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import React from 'react';
import { Button, Alert } from 'react-bootstrap';
import * as S from './styles';
export interface IBodyCompProps {
  email?: string;
  imageUrl?: string;
  headerTitle?: string;
  headerSubTitle?: string;
  subTitle?: string;
  discount?: string;
  discountSubTitle?: string;
  description?: string;
  buttonTitle?: string;
  premium?: string;
  discountPremium?: string;
  policyNumber?: string;
  policyTitle?: string;
  verifyPhone?: boolean;
  verifyPhoneText?: string;
  verifyButtonText?: string;
  onButtonClick?(): void;
  onVerifyPhoneClick?(): void;
}

export const PolicyPurchaseStatus = (props: IBodyCompProps) => {
  const {
    email,
    headerTitle,
    headerSubTitle,
    subTitle,
    discount,
    discountSubTitle,
    description,
    buttonTitle,
    imageUrl,
    policyTitle,
    policyNumber,
    verifyPhone,
    verifyButtonText,
    verifyPhoneText,
    discountPremium,
    premium,
    onVerifyPhoneClick,
    onButtonClick,
  } = props;

  const _getDiscount = () => {
    if (premium !== discountPremium) {
      return (
        <S.Title>
          <Alert variant="success">
            {discount} {` ${premium} ${discountSubTitle} ${discountPremium}`}
          </Alert>
        </S.Title>
      );
    }
    return null;
  };
  return (
    <>
      <S.Background>
        <S.Image alt={'success'} src={imageUrl} width={200} />
        <S.Title>{headerTitle} </S.Title>
        <S.Title>
          {policyTitle} {policyNumber}
        </S.Title>
        <S.Title>
          {headerSubTitle} {email}
        </S.Title>
        {_getDiscount()}
        <S.SubTitle>{subTitle}</S.SubTitle>
        <S.Description>{description}</S.Description>
        {verifyPhone && (
          <S.VerifyPhoneText>
            <S.VerifyButtonText
              onClick={() => {
                onVerifyPhoneClick && onVerifyPhoneClick();
              }}
            >
              {verifyButtonText}
            </S.VerifyButtonText>{' '}
            {verifyPhoneText}
          </S.VerifyPhoneText>
        )}
        <S.ButtonContainer>
          <Button
            className="me-3 mb-4"
            variant="outline-secondary"
            size="lg"
            onClick={onButtonClick}
          >
            {buttonTitle}
          </Button>
        </S.ButtonContainer>
      </S.Background>
    </>
  );
};
PolicyPurchaseStatus.defaultProps = {
  imageUrl:
    'https://s3.ap-south-1.amazonaws.com/io.vlinder.images/provisionalpolicy_screen.png',
  headerTitle: 'Thank You !',
  headerSubTitle:
    'Your Provisional Policy FHP-202305-PP-0005 has been issued and stored online, and a copy has been emailed to you at ',
  subTitle:
    'You can access this policy by selecting Pay My Policies from the navigation panel.',
  description:
    'Please remember that the full premium must be paid before May 31, 2023 or your policy will be cancelled.',
  buttonTitle: 'View My Policies',
  verifyPhoneText: 'To receive further notification via SMS please',
  verifyButtonText: 'Verify your phone number',
};
